import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import toastr from "toastr";
import { priceItemSubmit } from "../redux/project/projActions";
import PriceStatusModal from "./PriceStatusModal";
import ConfirmDialog from "../shared/confirmBox/confirmDialog";

const MAX_TAGS_TO_PROCESS = 50;

const ItemPrice = (props) => {
  const { gridApi, priceOption, setOpenItemPrice } = props;
  const { t } = useTranslation();
  const profileState = useSelector((state) => state.profile);
  const dispatch = useDispatch();
  const pkg = useSelector((state) => state.ctrl.pkg);
  const project = useSelector((state) => state.ctrl.data);

  const [isPriceStatusDialogOpen, setIsPriceStatusDialogOpen] = useState(false);
  const [rowsForPayload, setRowsForPayload] = useState([]);
  const [isConfirmDialoagOpen, setIsConfirmDialoagOpen] = useState(false);
  useEffect(() => {
    handlePriceAction();
  }, []);

  const createPricePayload = (tags) => {
    return {
      submitted_by: profileState.email,
      tags: tags.map((tag) => ({
        tag_id: tag.tag_id,
        package_id: tag.package_id,
        package_name: pkg.package_name,
        project_id: tag.project_id,
        project_name: project.project_name,
        revision: tag.revision,
        part_number: tag.gen_part_num,
        gen_technology_type: tag.gen_technology_type,
        gen_prod_desc: tag.gen_prod_desc,
        currency: pkg.currency,
        pricing_region: pkg.pricing_region,
        pricing_date: pkg.pricing_date,
        quantity: tag.quantity,
        config_status: tag.config_status,
      })),
    };
  };

  const handlePriceAction = () => {
    if (priceOption === "STATUS") {
      setIsPriceStatusDialogOpen(true);
      return;
    }

    // Handle PRICE option
    const selectedNodes = gridApi.getSelectedNodes();

    if (selectedNodes.length === 0) {
      toastr.error(t("Please Select the Tag line"));
      setOpenItemPrice(false);
      return;
    }

    // Filter nodes without part numbers
    filterInvalidNodes(selectedNodes);

    const validNodes = gridApi.getSelectedNodes();
    if (validNodes.length === 0) {
      toastr.error(t("Please enter the Part Number and Product Group or remove the Base Model"));
      setOpenItemPrice(false);
      return;
    }

    setRowsForPayload(validNodes.map(node => node.data));
    setIsConfirmDialoagOpen(true);
  };

  const filterInvalidNodes = (nodes) => {
    nodes.forEach(node => {
      const hasBaseModel = node.data.gen_base_model_1;
      const hasPartNumber = node.data.gen_part_num;
      const hasDivision = node.data.division_code && node.data.division_code.trim() !== "";
      if (!hasPartNumber || hasBaseModel || !hasDivision) {
        node.setSelected(false);
      }
    });

  };

  const handleConfirmDialogClose = () => {
    setIsConfirmDialoagOpen(false);
    setOpenItemPrice(false);
  };

  const handleConfirmDialogSubmit = () => {
    setIsConfirmDialoagOpen(false);
    const rowsToProcess = rowsForPayload.length > MAX_TAGS_TO_PROCESS
      ? rowsForPayload.slice(0, MAX_TAGS_TO_PROCESS)
      : rowsForPayload;
    const pricePayload = createPricePayload(rowsToProcess);
    dispatch(priceItemSubmit(pricePayload));
    setRowsForPayload([]);
    setOpenItemPrice(false);
  };

  return (
    <>
      {isConfirmDialoagOpen && (
        <ConfirmDialog
          open={isConfirmDialoagOpen}
          handleClose={handleConfirmDialogClose}
          okBtnLbl="Ok"
          cnclBtnLbl="Cancel"
          dlgTitle="Price Part"
          dlgContent={
            rowsForPayload.length > 50
              ? `You have selected ${rowsForPayload.length} tags. Only the first ${MAX_TAGS_TO_PROCESS} tags with non-empty Part Numbers and Product Group will be processed. Do you want to proceed?`
              : `Only tags with non-empty Part Number and Product Group will be processed. Do you want to proceed?`
          }
          submitFunction={handleConfirmDialogSubmit}
        />
      )}

      {isPriceStatusDialogOpen && (
        <PriceStatusModal
          isPriceStatusDialogOpen={isPriceStatusDialogOpen}
          setIsPriceStatusDialogOpen={setIsPriceStatusDialogOpen}
          setOpenItemPrice={setOpenItemPrice}
        />
      )}
    </>
  );
};

export default ItemPrice;
